:host{display:flex;flex-direction:column;height:100%}
/*# sourceMappingURL=admin-panel-user-detail-form.component-FBP7XFV2.css.map */
